module.exports = __webpack_public_path__ + "static/media/Fashin & beatuy.e203ec53.svg";